export default "__VITE_ASSET__Bntn$OiY__"